<template>
  <div class="container">
    <div class="vd">
      <img src="../assets/banner.jpg" />
      <p class="sxt">
        <span>当前{{zxtotal}}个摄像头在线</span>
        <span>共安装{{total}}个摄像头</span>
      </p>
    </div>
    <div class="vd">
      <div class="bt" @click="show()">购买网络摄像头</div>
      <div class="bt" @click="show()">联系安装师傅</div>
    </div>
  </div>
</template>

<script>
import { getmonitoringdevicelist } from "@/api/bapi";
export default {
  name: "Video",
  data() {
    return {
      items: [
        {
          url: "http://www.didichuxing.com/",
          image: "http://www.zixunxueli.com/img/banner.jpg"
        }
      ],
      total:0,
      zxtotal:0,
      userInfo:{},
      token:'',
    };
  },
  watch: {
    $route(to, from) {
      if (/\/AddSource/gi.test(to.path)) {
        this.userInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
        this.token = localStorage.getItem("access_token");
        this.getInfo();
      }
    }
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    this.token = localStorage.getItem("access_token");
    this.getInfo();
  },
  methods: {
    show()
    {
          const toast = this.$createToast({
        time: 1000,
        txt: '即将上线，尽请期待'
      })
      toast.show()

    },
    getInfo() {
      getmonitoringdevicelist({
        current: 1,
        size: 20,
        companyId: this.userInfo.org.orgId
      })
        .then(res => {

          this.total = res.data.data.total;
          if(res.data.data.records)
          {
            let zx=0;
            res.data.data.records.forEach(o=>{
              if(o.realStatus==0)
              {
                zx++;
              }
            })
            this.zxtotal=zx;
          }
        })
        .catch(function(reason) {
          this.$Message.error("您暂无权限");
        });
    }
  }
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
.bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-color: #f5f5f5;
}
.top {
  height: 3rem;
  background-color: #45b035;
}
.logo {
  width: 30%;
  line-height: 3rem;
}
.logo img {
  width: 100%;
  margin-top: 10px;
}
.tab {
  position: fixed;
  width: 100%;
  bottom: 0;
  border-top: 1px solid #f1ebeb;
  background-color: white;
}
.nav {
  list-style: none;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1ebeb;
  background-color: white;
}
.nav a {
  color: #333333;
}
.nav li {
  width: 33%;
  padding: 10px 0;
}
.nav li:hover {
  color: #45b035;
}
.current {
  color: #45b035;
}
.banner img {
  width: 100%;
}
.introduce {
  text-align: left;
  font-size: 0.8rem;
  color: #999999;
  padding: 0rem 1rem;
  background-color: white;
  margin: 0 0.5rem;
  padding: 0.8rem;
  border-radius: 6px;
  z-index: 1;
  position: relative;
  top: -20px;
}
.introduce p {
  margin-bottom: 0.5rem;
}
.store {
  background-color: white;
  padding: 0.8rem;
}
h3 {
  font-size: 0.9rem;
  text-align: left;
  position: relative;
  padding-left: 10px;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 10px;
}
h3:before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 3px;
  height: 16px;
  background-color: #45b035;
}
.img_content {
  display: flex;
  margin: 10px 0;
  justify-content: space-around;
}
.store p {
  width: 30%;
}
.store p img {
  width: 100%;
}
.list {
  padding-bottom: 60px;
  margin-top: 10px;
}
.left_img {
  width: 30%;
}
.left_img img {
  width: 100%;
}
.list_content {
  display: flex;
  padding: 5px;
  margin-top: 10px;
  box-shadow: 0px 0px 3px #ece6e6;
}
.title {
  width: 70%;
  text-align: left;
}
h4 {
  font-size: 1rem;
  margin-top: 1.3rem;
  color: #2c3e50;
  margin-left: 1rem;
}
.sub {
  font-size: 0.8rem;
  margin-top: 1.3rem;
  color: red;
  margin-left: 1rem;
}
.more {
  float: right;
  color: #b8b8b8;
  font-size: 0.8rem;
}
.look {
  float: right;
  color: #45b035;
}
.it {
  font-size: 0.6rem;
  margin: 5px 0;
  margin-left: 1rem;
}
.ej {
  position: absolute;
  width: 100%;
  background-color: #45b035;
  left: 0;
  top: 38px;
  z-index: 100;
  text-align: right;
}
.ej li {
  width: 100%;
  text-align: center;
  color: white;
  border-bottom: 1px solid #fff;
}

.ej li a {
  width: 100%;
  text-align: center;
  color: white;
}
.ej li a:hover {
  color: white;
}
.vd img {
  width: 100%;
}
.sxt {
  overflow: hidden;
  margin: 10px auto;
  width: 90%;
  color: #999999;
  font-size: 0.8rem;
}
.sxt span:nth-child(1) {
  float: left;
}
.sxt span:nth-child(2) {
  float: right;
}
.vd .bt {
  width: 90%;
  padding: 15px;
  margin: 20px auto;
  text-align: center;
  color: white;
  background-color: #fc9153;
}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue